module.exports = __webpack_public_path__ + "static/poppins-v5-latin-800-0aca950ff11dc2a7183a44780d9278a8.svg";